var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1271_426)","key":0},[React.createElement("rect",{"x":"-6.10352e-05","width":"115","height":"55","rx":"27.5","fill":"black","key":0}),React.createElement("rect",{"x":"176","y":"119","width":"115","height":"55","rx":"27.5","transform":"rotate(180 176 119)","fill":"black","key":1}),React.createElement("rect",{"x":"121","width":"55","height":"55","rx":"27.5","fill":"black","key":2}),React.createElement("rect",{"x":"54.9999","y":"119","width":"55","height":"55","rx":"27.5","transform":"rotate(180 54.9999 119)","fill":"black","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1271_426"},React.createElement("rect",{"width":"176","height":"119","fill":"white"})))]);
}

Grid.defaultProps = {"width":"176","height":"119","viewBox":"0 0 176 119","fill":"none"};

module.exports = Grid;

Grid.default = Grid;
